<template>
    <div class="white-bg">
        <vue-basic-alert ref="alert" />
        <router-view />
    </div>
</template>

<script>
import {provide, ref} from "vue";
import Menu from "@/components/Menu";
import VueBasicAlert from "vue-basic-alert";

export default {
    name: "CreateProjectLayout",
    components: {Menu, VueBasicAlert},
    setup() {
        const alert = ref();
        provide('alert', alert);

        return {
            alert
        }
    }
}
</script>

<style scoped lang="scss">
.white-bg {
    background-color: #fff;
    min-height: 100vh;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    padding: 40px 5px;
}
</style>